import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import TripCardHelp from '../../TripCardHelp';
import { Message } from '../styles';
import { XCircleIcon } from './styles';

const Cancelled = () => {
  const { t } = useStoreTranslation();

  return (
    <TripCardHelp icon={<XCircleIcon />} withContactButtons title={t('customerSupport.cancelled.title')}>
      <Message>{t('customerSupport.cancelled.message')}</Message>
    </TripCardHelp>
  );
};

export default Cancelled;
